import { InternalEventType } from '@/domain/enums/internal-event-type';
import { IFacebookSignInResult } from './facebook-signin-result.interface';
import { UnknownFacebookError } from './errors/unknown-facebook-error';
import importModule from '@/utils/dynamic-import-polyfill';
import globals from '@/utils/globals';

const GRAPH_API_VERSION = 'v26.0';

export class FacebookClient {
	private static sdkPromise: Promise<void> | null = null;
	private static sdkReady = false;

	constructor(private appId: string) {}

	public initializeSDK(): Promise<void> {
		if (!FacebookClient.sdkPromise) {
			FacebookClient.sdkPromise = this.loadSDK().catch((error) => {
				FacebookClient.sdkPromise = null;
				throw error;
			});
		}

		return FacebookClient.sdkPromise;
	}

	public login(): Promise<IFacebookSignInResult> {
		if (FacebookClient.sdkReady) {
			return this.getAuthCode().then((code) => ({ code }));
		}

		return this.initializeSDK()
			.then(() => this.getAuthCode())
			.then((code) => ({ code }));
	}

	private async loadSDK(): Promise<void> {
		await importModule('//connect.facebook.net/en_US/sdk.js', null);

		FB.init({
			appId: this.appId,
			autoLogAppEvents: true,
			xfbml: true,
			version: GRAPH_API_VERSION,
		});

		FacebookClient.sdkReady = true;
		globals.eventBus.emit(InternalEventType.FACEBOOK_INITIALIZED);
	}

	private getAuthCode(): Promise<string> {
		return new Promise((resolve, reject) => {
			FB.login(
				(response) => {
					if (response.status === 'connected') {
						resolve(response.authResponse.accessToken as string);
						return;
					}
					reject(new UnknownFacebookError(response));
				},
				{ scope: 'email', return_scopes: true },
			);
		});
	}
}
